
import { useState, useEffect } from 'react';
import HireNavbar from './components/HireNavbar';
import HireHero from './components/HireHero';
import PortableBarsSection from './components/PortableBarsSection';
import BarMatsSection from './components/BarMatsSection';
import ConsumablesSection from './components/ConsumablesSection';
import PartyGlasswareSection from './components/PartyGlasswareSection';
import PartyTablesSection from './components/PartyTablesSection';
import DisplayBoardsSection from './components/DisplayBoardsSection';
import PartyHelpersSection from './components/PartyHelpersSection';
import CataloguePdfDownload from './components/CataloguePdfDownload';
import BookingCalendar from './components/BookingCalendar';
import HireInquiryForm from './components/HireInquiryForm';
import HireTestimonials from './components/HireTestimonials';
import HireFooter from './components/HireFooter';

export default function EquipmentHirePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <HireNavbar scrolled={scrolled} />
      <main>
        <HireHero />
        <PortableBarsSection />
        <BarMatsSection />
        <PartyGlasswareSection />
        <PartyTablesSection />
        <DisplayBoardsSection />
        <PartyHelpersSection />
        <ConsumablesSection />
        <CataloguePdfDownload />
        <BookingCalendar />
        <HireTestimonials />
        <HireInquiryForm />
      </main>
      <HireFooter />
    </div>
  );
}
